import HBIcon from "@/components/HBIcon";
import { TrackerLink } from "@/components/Tracker";
import useAppStore from "@/context/store";
import classNames from "classnames";
import { useRouter } from "next/router";
import { useLogin } from "../LoginModal";
import styles from "./NavItem.module.less";

export default function NavItem({
  icon,
  title,
  link,
  openInNewTab,
  isCollapsed,
  onClick,
  loginRequired,
  customActiveCheck,
  id,
  extraElement,
  index,
}) {
  const router = useRouter();
  const user = useAppStore((state) => state.user);
  const { login } = useLogin();

  const isActive = () => {
    if (customActiveCheck) {
      return customActiveCheck(router.pathname);
    }
    return router.asPath.startsWith(link);
  };

  const handleClick = async (e) => {
    let isLogin = !!user?.user_id;
    if (loginRequired && !user) {
      e.preventDefault();
      isLogin = await login({
        source_location: "左侧导航" + title,
      });
    }

    if (onClick) {
      e.preventDefault();
      onClick();
    }

    // // 对于"灵感"和"我的"菜单项，使用直接浏览器访问
    // 只有当 link 有值时才执行跳转
    if (title === "我的" && isLogin) {
      link = "/space";
    }

    if ((title === "灵感" || title === "我的") && link) {
      e.preventDefault();
      window.location.href = link;
    }
  };

  return (
    <TrackerLink
      href={link || "#"}
      id={id}
      className={classNames(styles.navItem, {
        [styles.active]: isActive(),
        [styles.collapsed]: isCollapsed,
      })}
      target={openInNewTab ? "_blank" : undefined}
      onClick={handleClick}
      data-tooltip={isCollapsed ? (openInNewTab ? title + " ↗" : title) : null}
      data-gd-expose="resource_loc_expose"
      data-gd-click="resource_loc_click"
      data-tooltip-position="right"
      data-module-name="左侧导航栏"
      data-subject-name="资源位"
      data-apply-client="使用端"
      data-resource-title={title}
      data-resource-location={index + 1}
    >
      <span className={styles.icon}>
        <HBIcon type={icon} />
      </span>
      {!isCollapsed && (
        <>
          <span className={styles.title}>{title}</span>
          {extraElement && <span className={styles.extra}>{extraElement}</span>}
          {!extraElement && openInNewTab && (
            <HBIcon type="ic_open" className={styles.linkIcon} />
          )}
        </>
      )}
    </TrackerLink>
  );
}
